module.exports = __WEBPACK_EXTERNAL_MODULE_202__;


//////////////////
// WEBPACK FOOTER
// external "detectie"
// module id = 202
// module chunks = 0